// import Element's files to get the additional method description on yup for cardElements
import '../components/util/stripe-custom/CardElement'

import * as yup from 'yup'

export const DogInfoSchema = yup.object({
  name: yup
    .string()
    .trim()
    .matches(/^[A-Za-z][A-Za-z\s'.-]*$/, 'Name cannot contain special characters')
    .required('Name is required'),
  neutered: yup.string().required('Neutered is required'),
  breed: yup.array(),
  // .max(2, 'Max of 2 breeds')
  // .of(
  //   yup.object().shape({
  //     label: yup.string().required('Breed is required'),
  //     value: yup.string().required('Breed is required')
  //   })
  // ),
  gender: yup.string().required('Gender is required'),
  ageStage: yup.string().required('Age Stage is required'),
  dob: yup.string().required('Year of birth is required'),
  dobMonth: yup.string(),
  weight: yup
    .number()
    .min(1, 'Weight must be above 1kg')
    .max(75, 'Weight must be below 75kg')
    .required('Weight is required'),
  physique: yup.string().required('Physique is required'),
  exercise: yup.string(),
  medicalConditionOrAllergies: yup.string().required('Medical conditions or allergies is required'),
  allergies: yup.array(),
  fussy: yup.string().required('Eating preference is required'),
  typeOfFood: yup.array().required('Type of Food is required'),
  email: yup
    .string()
    .matches(
      /^(([^<>'’()[\]\\.,;:\s@"]+(\.[^<>'’()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Invalid email address'
    ),
  marketingOptIn: yup.boolean()
})

export const DogNameSchema = yup.object({
  name: yup
    .string()
    .trim()
    .matches(/^[A-Za-z][A-Za-z\s'.-]*$/, 'Name cannot contain special characters')
    .required('Name is required')
})

export const ParentDetailSchema = yup.object({
  firstName: yup
    .string()
    .trim()
    .matches(/^[a-zA-Z_.\-' ]+$/, 'First name cannot contain special characters')
    .required('First Name is required'),
  lastName: yup
    .string()
    .trim()
    .matches(/^[a-zA-Z_.\-' ]+$/, 'Last name cannot contain special characters')
    .required('Last Name is required'),
  email: yup
    .string()
    .matches(
      /^(([^<>'’()[\]\\.,;:\s@"]+(\.[^<>'’()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Invalid email address'
    )
    .required('Email is required'),
  offers: yup.boolean(),
  coupon: yup.string()
})

export const ParentDetailAlternativeSchema = yup.object({
  firstName: yup
    .string()
    .trim()
    .matches(/^[a-zA-Z_.\-' ]+$/, 'Name cannot contain special characters')
    .required('Name is required'),
  lastName: yup.string(),
  email: yup
    .string()
    .matches(
      /^(([^<>'’()[\]\\.,;:\s@"]+(\.[^<>'’()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Invalid email address'
    )
    .required('Email is required'),
  offers: yup.boolean(),
  coupon: yup.string()
})

export const PlanDetailSchema = yup.object({
  packType: yup.string().required('Please select a plan'),
  trialCheckbox: yup.string()
})

export const RecipesSchema = yup.object({
  recipes: yup.array().required('Please select recipes')
})

export const TreatsSchema = yup.object({
  treats: yup.array().required('Please select treats')
})
export const SupplementsSchema = yup.object({
  supplements: yup.array().required('Please select items')
})

export const ShippingSchema = yup.object({
  firstName: yup.string().required('Please enter your first name'),
  lastName: yup
    .string()
    .trim()
    .matches(/^[a-zA-Z_.\-' ]+$/, 'Last name cannot contain special characters')
    .required('Please enter your last name'),
  email: yup
    .string()
    .matches(
      /^(([^<>'’()[\]\\.,;:\s@"]+(\.[^<>'’()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Invalid email address'
    )
    .required('Email is required'),
  phoneNumber: yup
    .string()
    .required('Please enter a correct mobile number')
    .matches(/^(?:\+44|44|0)(1|2|7)\d{9}$/, 'Please enter a valid mobile number'),
  deliveryDate: yup.string().required('Please select delivery date'),
  shippingAddressSearch: yup.string(),
  shippingAddress1: yup.string().required('Please enter the first line of your address'),
  shippingAddress2: yup.string(),
  shippingCity: yup.string().required('Please enter your city'),
  shippingCounty: yup.string().required('Please enter your county'),
  shippingPostcode: yup.string().required('Please enter your postcode'),
  coupon: yup.string(),
  billingFirstName: yup.string(),
  billingLastName: yup.string(),
  billingAddressSearch: yup.string(),
  billingAddress1: yup.string(),
  billingAddress2: yup.string(),
  billingCity: yup.string(),
  billingCounty: yup.string(),
  billingPostcode: yup.string(),
  smsOptIn: yup.boolean()
})

export const AccountShippingSchema = yup.object({
  deliveryDate: yup.string().required('Please select delivery date'),
  shippingAddressSearch: yup.string(),
  shippingAddress1: yup.string().required('Please enter the first line of your address'),
  shippingAddress2: yup.string(),
  shippingCity: yup.string().required('Please enter your city'),
  shippingCounty: yup.string().required('Please enter your county'),
  shippingPostcode: yup.string().required('Please enter your postcode')
})

export const AccountReviewPlanSchema = yup.object({
  deliveryDate: yup.string().required('Please select delivery date')
})

export const ContactUsSchema = yup.object({
  name: yup.string(),
  surname: yup.string(),
  email: yup
    .string()
    .matches(
      /^(([^<>'’()[\]\\.,;:\s@"]+(\.[^<>'’()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Invalid email address'
    ),
  subject: yup.string(),
  message: yup.string().max(500, 'Message must be at most 500 characters')
})
